import React from "react";
import { Helmet } from "react-helmet-async";

const MetaInformation = (props) => {
  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name={props.name} content={props.content} />
    </Helmet>
  );
};

export default MetaInformation;
